(() => {
  const init = () => {
    initLoading();
  };

  // EventListener
  window.addEventListener("DOMContentLoaded", init);
})();

/**
 * loading
 */
const initLoading = () => {
  const loadingScreen = document.getElementById("loading");
  const anime1 = document.querySelector(".anime--1");
  const anime2 = document.querySelector(".anime--2");
  const wrapper = document.getElementById("wrapper");
  const mvMovie = document.querySelector(".mv video");

  // Safari対策: 動画の再生準備
  if (mvMovie) {
    mvMovie.muted = true; // Safariでの再生ポリシーを満たすためにミュート
    mvMovie.pause();
    mvMovie.currentTime = 0;
  }

  // アニメーション順序制御
  const showAnimation = () => {
    anime1.classList.add("active");

    setTimeout(() => {
      anime1.classList.remove("active");
      anime2.classList.add("active");

      setTimeout(() => {
        anime1.classList.remove("active"); // anime--1を非表示
        anime2.classList.add("finished"); // アニメーション終了状態を明示

        // ローディング画面をフェードアウト
        loadingScreen.style.transition = "opacity 0.5s";
        loadingScreen.style.opacity = "0";

        // 完全に非表示になった後に削除し、メインコンテンツを表示
        loadingScreen.addEventListener("transitionend", () => {
          loadingScreen.style.display = "none";
          wrapper.classList.add("show");

          // 動画の再生をローディング完了後に開始
          if (mvMovie) {
            mvMovie.play().catch((error) => {
              console.error("動画の再生に失敗しました:", error);
            });
          }
        });
      }, 2000); // anime2の表示時間
    }, 1400); // anime1の表示時間
  };

  // ローディング画面が表示された後にアニメーションを開始
  setTimeout(showAnimation, 600);
};